/* eslint-disable curly */
import React, { Component, useEffect, useRef, useState } from "react";
import {
  View,
  Text,
  Dimensions,
  TextInput,
  TouchableOpacity,
  Keyboard,
  Animated,
  Platform,
  ScrollView,
  Switch,
  KeyboardAvoidingView,
  Linking,
  ImageBackground,
} from "react-native";
import { StackActions } from "react-navigation";
import { EventRegister } from "react-native-event-listeners";
import Icon from "react-native-vector-icons/FontAwesome";
import IconE from "react-native-vector-icons/Entypo";

import styles from "./styles";
import ButtonConfirm from "../../components/ButtonConfirm";
import Loading from "../../components/Loading";
import {
  getAluno,
  atualizar as atualizarAluno,
} from "../../services/aluno-service";
import { alert } from "../../utils/alerts";

// const widthScreen = Dimensions.get("screen").width;
// const widthInput = "90%";

const EditarDadosProfissionais = ({ navigation }) => {
  const [aluno, setAluno] = useState({});
  const [linkCurriculo, setLinkCurriculo] = useState("");
  const [trabalhando, setTrabalhando] = useState(false);
  const [procurandoTrabalho, setProcurandoTrabalho] = useState(false);

  const [loading, setLoading] = useState(false);
  const [confirmDisabled, setConfirmDisabled] = useState(true);

  const handlerLinkCurriculo = async (e) => {
    setLinkCurriculo(e.trim());
  };

  useEffect(() => {
    const carregarDados = async () => {
      const aluno = await getAluno();

      setTrabalhando(aluno.trabalhando === 1);
      setProcurandoTrabalho(aluno.procurando_trabalho === 1);
      setLinkCurriculo(aluno.link_curriculo || "");

      setAluno(aluno);
    };

    carregarDados();
  }, []);

  const enviar = async () => {
    setLoading(true);

    let isValidLink = true;

    if (linkCurriculo) isValidLink = await Linking.canOpenURL(linkCurriculo);

    if (!isValidLink) {
      setLoading(false);
      setLinkCurriculo("");
      return alert("Ops", "O Link que você forneceu é inválido.");
    }

    const alunoAtualizar = {
      trabalhando,
      procurando_trabalho: procurandoTrabalho,
      link_curriculo: linkCurriculo || null,
      cpf: aluno.cpf,
    };

    try {
      const response = await atualizarAluno(alunoAtualizar);

      if (!response.ok) {
        let { erro } = await response.json();
        setLoading(false);
        return alert("Ops...", erro);
      }

      await response.json();

      Keyboard.dismiss();
      EventRegister.emit("reloadPerfil", "it works!!!");
      EventRegister.emit("reloadHome", "it works!!!");
      setLoading(false);

      navigation.pop(1);
    } catch (erro) {
      setLoading(false);
      console.log(erro);
      alert(
        "Ops...",
        "Houve um problema ao consultar, verifique o numero e tente novamente"
      );
    }
  };

  return (
    <>
      {loading && <Loading />}
      <KeyboardAvoidingView
        style={styles.container}
        behavior={Platform.select({
          ios: "padding",
          android: "null",
        })}
        keyboardVerticalOffset={Platform.select({ ios: 64, android: 64 })}
      >
        <ImageBackground
          source={require("../../../resources/imgs/bg.jpg")}
          style={styles.container}
          imageStyle={styles.imageContainer}
        >
          <View style={[styles.containerForm, { paddingBottom: 55 }]}>
            <ScrollView
              style={{ height: 100, width: "100%" }}
              contentContainerStyle={{
                alignItems: "center",
                paddingHorizontal: 10,
              }}
            >
              <Text style={styles.textHeader1}>
                Você está empregado atualmente?
              </Text>
              <View style={{ flexDirection: "row" }}>
                <Switch
                  style={{ transform: [{ scaleX: 1.5 }, { scaleY: 1.5 }] }}
                  trackColor={{ false: "#FFF", true: "#FFF" }}
                  thumbColor={trabalhando ? "#00CC00" : "#CC0000"}
                  ios_backgroundColor="#FFF"
                  onValueChange={() => setTrabalhando(!trabalhando)}
                  value={trabalhando}
                />
                <Text
                  style={[styles.label, { fontSize: 25, marginLeft: 5 }]}
                  onPress={() => setTrabalhando(!trabalhando)}
                >
                  {trabalhando ? "Sim" : "Não"}
                </Text>
              </View>
              <View style={styles.hr}></View>
              <Text style={styles.textHeader1}>
                Podemos te enviar oportunidades de trabalho?
              </Text>
              <View style={{ flexDirection: "row" }}>
                <Switch
                  style={{ transform: [{ scaleX: 1.5 }, { scaleY: 1.5 }] }}
                  trackColor={{ false: "#FFF", true: "#FFF" }}
                  thumbColor={procurandoTrabalho ? "#00CC00" : "#CC0000"}
                  ios_backgroundColor="#FFF"
                  onValueChange={() =>
                    setProcurandoTrabalho(!procurandoTrabalho)
                  }
                  value={procurandoTrabalho}
                />
                <Text
                  style={[styles.label, { fontSize: 25, marginLeft: 5 }]}
                  onPress={() => setProcurandoTrabalho(!procurandoTrabalho)}
                >
                  {procurandoTrabalho ? "Sim" : "Não"}
                </Text>
              </View>
              <View style={styles.hr}></View>
              <Text style={styles.textHeader1}>
                {linkCurriculo === ""
                  ? "Cole abaixo o link para o seu curriculo na nuvem"
                  : "Link do Currículo"}
              </Text>
              <TextInput
                style={[
                  styles.input,
                  {
                    flex: 1,
                    textAlign: "left",
                    paddingStart: 10,
                    fontSize: 20,
                  },
                ]}
                placeholder={`https://drive.google.com/...`}
                placeholderTextColor="#ccc"
                multiline={false}
                autoCapitalize="none"
                autoFocus={false}
                value={linkCurriculo}
                onChangeText={handlerLinkCurriculo}
              />
              <TouchableOpacity
                style={{ marginTop: 20, alignItems: "center" }}
                onPress={() => {
                  alert(
                    "Dica",
                    ` Recomendamos que você suba o seu curriculo em PDF para a nuvem. \n\n  Assim você precisa apenas enviar o link de acesso público. \n\n Quando precisar fazer alterações, já atualiza para todos que tem o link. \n\n Sugestões: Google Drive,  OneDrive e Dropbox.`
                  );
                }}
              >
                <IconE
                  name="help-with-circle"
                  size={35}
                  // style={{ marginRight:  }}
                  color="#DDD"
                />
                <Text style={{ color: "#DDD", marginTop: 5 }}>
                  Precisa de ajuda?
                </Text>
              </TouchableOpacity>
            </ScrollView>
            <ButtonConfirm
              text={loading ? "Salvando..." : "Salvar"}
              disabled={false}
              onPress={enviar}
              msgDisabled={""}
            />
          </View>
        </ImageBackground>
      </KeyboardAvoidingView>
    </>
  );
};

EditarDadosProfissionais.navigationOptions = ({ navigation }) => {
  return {
    headerStyle: {
      backgroundColor: "#0F0F0F",
    },
    headerTitleStyle: {
      color: "#FFF",
    },
    headerLeft: () => (
      <TouchableOpacity
        onPress={() => {
          const navigateAction = StackActions.pop(1);
          navigation.dispatch(navigateAction);
        }}
      >
        <Icon
          style={styles.iconToggle}
          name="arrow-left"
          size={20}
          color="#F1F1F1"
        />
      </TouchableOpacity>
    ),
  };
};

export default EditarDadosProfissionais;
